import { Message } from "primereact/message"
import gpraStyles from "../../../styles/Participant-GPRA.module.css"
const FormError = (props) => {
  const { error, type } = props
  return (
    <>
      {error && (
        <Message
          className={type === 1 ? gpraStyles.error1 : gpraStyles.error}
          severity="error"
          text={error}
        />
      )}
    </>
  )
}
export default FormError
